import { EllipsisLabel } from '@frontend/app/refresh-components/EllipsisLabel';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

interface MemberPostTypesProps {
  value: number;
  postType: string;
}

const MemberPostTypes: React.FC<MemberPostTypesProps> = ({ value, postType }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  searchParams.set('postTypes', postType.toUpperCase());

  return (
    <Link
      to={{
        pathname: '/social/analytics/members',
        search: searchParams.toString(),
      }}
      className="block w-full"
      data-dd-action-name="networks-table-member-post-types-click"
    >
      <EllipsisLabel
        align="left"
        tooltip={value.toString()}
        width="auto"
        className="text-blue-600 hover:text-blue-800 hover:underline"
      >
        {value}
      </EllipsisLabel>
    </Link>
  );
};

export default MemberPostTypes;
